// import React, { Component } from 'react';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
// import styled from 'styled-components';
// import { MapContainer, TileLayer } from 'react-leaflet';

// const Wrapper = styled.div`
//     width: ${props =>props.width};
//     height: ${props=>props.height};
// `;

// export default class Map extends React.Component{
    
//     componentDidMount(){
//         this.map = L.map('map');

//         L.tileLayer('https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',{
//             attribution: '&copy; <a href="https://maps.app.goo.gl/WKxs4Zoph7DcCR1V8">OpenStreetMap</a> contributors' +
//             ', Tiles courtesy of <a href="https://geo6.be/">GEO-6</a>',
//             detectRetina: true,
//             maxZoom:20,
//             maxNativeZoom:17,
            

//         }).addTo(this.map);
//         var newMarkerGroup = new L.LayerGroup();
//         this.map.on('click', L.marker(L.latLng(27.7420, 85.3432), 12));


//         this.map.setView(new L.LatLng(27.7420, 85.3432), 12);

//         L.marker(new L.LatLng(27.7420, 85.3432), 12).addTo(this.map)
//         .bindPopup('New IT Venture')
//         .openPopup();
        
//         }

//         render(){
//             return <Wrapper width = "1280px" height='380px' id = 'map' />
//         }
//     }


import React, { Component } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export default class Map extends Component {
  render() {
    return (
      <Wrapper width="1280px" height="380px" id="map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d501.95078950999965!2d85.3293323!3d27.6978404!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19a38f1d1015%3A0x4797d5aafa23a2a!2sMusic%20Nepal%2C%20Kathmandu%2044600!5e1!3m2!1sen!2snp!4v1749024278631!5m2!1sen!2snp"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Music Nepal, Kathmandu"
        ></iframe>
      </Wrapper>
    );
  }
}



